module.exports = __webpack_public_path__ + "img/bg.a4c104a4.png";